import { Record } from "immutable";
import moment from "moment";

const defaults = {
    brand_id: undefined,
    payment_account_id: undefined,
    currency_code: undefined,
    key: undefined,
    start_date: undefined,
    end_date: undefined,
    avg_daily_transaction_volume: undefined,
    total_transaction_volume: undefined,
    avg_daily_gross_sales: undefined,
    total_gross_sales: undefined,
    high_volume_purchasers: undefined,
    transaction_aggregates: undefined,
    transaction_aggregates_view_type: undefined,
};

interface IPurchaser {
    name: string;
    gross_sales: number;
}

export class Summary extends Record(defaults) {
    declare brand_id: string;
    declare payment_account_id: string;
    declare currency_code: string;
    declare key: string;
    declare start_date: moment.Moment;
    declare end_date: moment.Moment;
    declare avg_daily_transaction_volume: number;
    declare total_transaction_volume: number;
    declare avg_daily_gross_sales: number;
    declare total_gross_sales: number;
    declare high_volume_purchasers: IPurchaser[];
    // Change this
    declare transaction_aggregates: any;
    declare transaction_aggregates_view_type: string;

    constructor(args) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            modified_on: moment.utc(args.modified_on),
            start_date: moment.utc(args.start_date),
            end_date: moment.utc(args.end_date),
        });
    }
}
